import React from 'react';
import cl from './AboutInfo.module.css';

const AboutInfo = (props) => {
    return (
        <section className={cl.about}>
          <div className={cl.about_div}>
            <img className={cl.big_image} src='https://assets.weforum.org/article/image/XaHpf_z51huQS_JPHs-jkPhBp0dLlxFJwt-sPLpGJB0.jpg'/>
            <div className={cl.about_ps}>
              <p className={cl.first_p_story}>{props.shopStory}</p>
            </div>
          </div>
      </section>
    );
}

export default AboutInfo;